// 10% welcome popup (snippets/singla-welcome-popup.liquid).
// Opens once per visitor after a short delay; closing it leaves a "Get 10% off" tab bottom-left.
if (!customElements.get('singla-welcome-popup')) {
  customElements.define('singla-welcome-popup', class SinglaWelcomePopup extends HTMLElement {
    constructor() {
      super();
      this.storeKey = 'singlaWelcome';
      this.modal = this.querySelector('.swp__modal');
      this.tab = this.querySelector('.swp__tab');
      this.tags = this.querySelector('[data-swp-tags]');
      this.form = this.closest('form');

      this.addEventListener('click', this.onClick.bind(this));
      this.modal.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      if (this.form) this.form.addEventListener('submit', () => this.remember('pending', 'session'));

      this.init();
    }

    remember(value, scope = 'local') {
      try {
        (scope === 'session' ? sessionStorage : localStorage).setItem(this.storeKey, value);
      } catch (e) {}
    }

    recall(scope = 'local') {
      try {
        return (scope === 'session' ? sessionStorage : localStorage).getItem(this.storeKey);
      } catch (e) {
        return null;
      }
    }

    init() {
      // Back from submitting this popup's form (the homepage signup uses the same form type).
      if (this.recall('session') === 'pending') {
        this.remember('', 'session');
        if (this.hasAttribute('data-posted')) {
          this.remember('subscribed');
          this.showStep(3);
          this.open();
          return;
        }
        if (this.hasAttribute('data-errors')) {
          this.showStep(2);
          this.open();
          return;
        }
      }

      const state = this.recall();
      if (state === 'subscribed') return;
      if (state === 'dismissed') {
        this.showTab();
        return;
      }

      // First visit: open after a short delay (not on the cart or checkout pages).
      if (window.location.pathname.startsWith('/cart')) {
        this.showTab();
        return;
      }
      const delay = Math.max(0, Number(this.dataset.delay || 4)) * 1000;
      setTimeout(() => {
        if (this.recall() !== 'dismissed' && this.recall() !== 'subscribed') this.open();
      }, delay);
    }

    open() {
      this.tab.hidden = true;
      this.classList.add('is-open');
      document.body.classList.add('swp-open');
      this.modal.focus();
    }

    close() {
      this.classList.remove('is-open');
      document.body.classList.remove('swp-open');
      if (this.recall() !== 'subscribed') {
        this.remember('dismissed');
        this.showTab();
      }
    }

    showTab() {
      if (this.recall('session') === 'tab-hidden') return;
      this.tab.hidden = false;
    }

    showStep(step) {
      this.querySelectorAll('[data-step]').forEach((el) => {
        el.hidden = el.dataset.step !== String(step);
      });
      if (step === 2) {
        const input = this.querySelector('.swp__input');
        if (input) setTimeout(() => input.focus(), 50);
      }
    }

    onClick(evt) {
      if (evt.target.closest('[data-swp-close]')) {
        this.close();
        return;
      }

      if (evt.target.closest('[data-swp-open]')) {
        this.showStep(1);
        this.open();
        return;
      }

      if (evt.target.closest('[data-swp-hide-tab]')) {
        this.tab.hidden = true;
        try {
          sessionStorage.setItem(this.storeKey, 'tab-hidden');
        } catch (e) {}
        return;
      }

      const answer = evt.target.closest('[data-swp-answer]');
      if (answer) {
        // Saved as a customer tag, e.g. "popup: Just looking".
        const label = answer.dataset.swpAnswer.replace(/,/g, ' ');
        this.tags.value = `newsletter,welcome-popup,popup: ${label}`;
        this.showStep(2);
        return;
      }

      const copy = evt.target.closest('[data-swp-copy]');
      if (copy) {
        const label = copy.querySelector('[data-swp-copy-label]');
        const done = () => {
          if (label) label.textContent = 'Copied';
        };
        if (navigator.clipboard) navigator.clipboard.writeText(copy.dataset.swpCopy).then(done, done);
        else done();
      }
    }
  });
}
